
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import useTranslation from "next-translate/useTranslation";
import { connect, ConnectedProps, useSelector } from "react-redux";
import { Col, Row, Spinner } from "reactstrap";
import { AnyAction, Dispatch } from "redux";
import { IProject, IProjectReport } from "@api/schema";
import BaseLayout from "@components/BaseLayout";
import PageNavigation from "@components/common/PageNavigation";
import { withAuthOnLoggedInOnlySetting } from "@components/hoc/withAuthOnLoggedInOnlySetting";
import ProjectStatusIndicator from "@components/marketplace/projects/ProjectStatusIndicator";
import ProjectCreatorText from "@components/project/ProjectCreatorText";
import ProjectNameText, { projectNameText } from "@components/project/ProjectNameText";
import PublicProfile from "@components/project/PublicProfile";
import { addNotificationAction } from "@redux/actions/notifications";
import { IFormikActions } from "@redux/helper/actions";
import { AppState } from "@redux/reducer";
import { selectRoles } from "@redux/reducer/auth";
import { isProjectMember } from "@redux/reducer/myProjects";
import { reportProjectAction } from "@redux/usecases/marketplace";
import { useInitialDataForProjectPage } from "@services/pageHelpers";
import { projectIllustrationPlaceholder } from "@services/projectHelper";
import { Routes } from "@services/routes";
import { idFromIModelOrIRI, prefixApiUrl } from "@services/util";
import { BASE_URL } from "config";
const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
    addNotification: (message: string) => dispatch(addNotificationAction(message, "success")),
    reportProject: (project: IProject, report: IProjectReport, actions: IFormikActions) => dispatch(reportProjectAction(project, report, actions)),
});
/*
 * @todo: remove mapDispatchToProps:
 * addNotification und reportProject sollten besser direkt von der publicProfile-Komponente verwaltet werden und nicht von
 * außen reingegeben werden müssen. -> https://futureprojects.atlassian.net/browse/FCP-1249
 */
const connector = connect(null, mapDispatchToProps);
type PageProps = ConnectedProps<typeof connector>;
/**
 * This page shows the public project profile, used in the marketplace.
 */
const PublicProjectProfilePage: React.FC<PageProps> = ({ addNotification, reportProject }: PageProps) => {
    const { t } = useTranslation("common");
    const { project, projectErrorOrSpinnerPage } = useInitialDataForProjectPage();
    const isMember = useSelector((state: AppState) => isProjectMember(state, idFromIModelOrIRI(project)));
    const roles = useSelector((state: AppState) => selectRoles(state));
    if (projectErrorOrSpinnerPage) {
        return projectErrorOrSpinnerPage;
    }
    // @todo: rework? https://futureprojects.atlassian.net/browse/FCP-1372
    // @todo: check for project.state === deactivated?
    const title = project && projectNameText(project, t);
    const imageUrl = project?.picture?.contentUrl ? (prefixApiUrl(project.picture.contentUrl)) : BASE_URL + projectIllustrationPlaceholder.path;
    const pageUrl = project ? (BASE_URL + "/projects/" + project.id.toString()) : '';
    const metaData = <>
    <meta name="description" content={project?.shortDescription || ''}/>
    <meta name="og:description" content={project?.shortDescription || ''}/>
    <meta name="og:image" content={imageUrl}/>
    <meta property="og:url" content={(typeof window !== "undefined") && String(window?.location) || pageUrl}/>
    <meta name="twitter:card" content={project?.picture ? 'summary_large_image' : 'summary'}/>
    <meta name="twitter:description" content={project?.shortDescription || ''}/>
    <meta name="twitter:image" content={imageUrl}/>
    <meta name="keywords" content={project?.categories?.map(c => c.title).join(',')}/>
    <meta name="author" content={project?.createdBy?.username}/>
    {/* <meta name="publisher" content={currentProcess.title} /> */}
    <link rel="canonical" href={pageUrl}/>
  </>;
    return <BaseLayout pageTitle={title} metaData={metaData}>
    <Row>
      <Col>
        {project
            ? <>
            <h1><ProjectNameText project={project}/></h1>
            <div className="d-flex align-items-center">
              <ProjectStatusIndicator project={project}/>
              <span className="ml-3"><ProjectCreatorText project={project}/></span>
            </div>
            <PageNavigation leftNavigation={{ href: Routes.Marketplace, title: "goto.marketplace" }}/>
          </>
            : <Spinner />}
      </Col>
    </Row>
    {project && <Row>
      <PublicProfile addNotification={addNotification} isMember={isMember} project={project} reportProject={reportProject} roles={roles}/>
    </Row>}

  </BaseLayout>;
};
const __Next_Translate__Page__191dbbefba8__ = withAuthOnLoggedInOnlySetting(connector(PublicProjectProfilePage));

    export default __appWithI18n(__Next_Translate__Page__191dbbefba8__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  